// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  font-family: 'rollcage', sans-serif;
  display: block;
  background: linear-gradient(#e66465, white) !important;
  text-align: center;
  height: 100vh;

}


.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.logo
{
  display: inline-block;
  background-color: red;
  color: white;
  font-size: 80px;
  text-align: center;
  width: 120px !important;
  height: 120px !important;
  border-radius: 20px;
}

.LogoText
{
   font-size: 90px;
   font-weight: semibold;
   margin-left: 25px;
   color:white;
}

.Description
{
   text-align: left;
   font-size:40px;
   line-height:1.2;
   color:white
}

.appimg1
{
  margin-top: 0px;
}

.avatar
{
  width: 100px;
  height: 100px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) { 
  .logo
  {
    width: 50px !important;
    height: 50px !important;
    font-size: 25px;
    border-radius: 10px;
  }

  .LogoText 
  {
    font-size: 50px;
  }

  .Description
  {
    font-size: 20px;
    line-height:1.2;
    text-align: justify;
  }

  .avatar
  {
    width: 60px;
    height: 60px;
  }

  .appimg1
  {
    margin-top: 30px;
  }

}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) { 
  .logo
  {
    width: 50px !important;
    height: 50px !important;
    font-size: 30px;
    border-radius: 10px;
  }

  .LogoText 
  {
    font-size: 50px;
  }

  .Description
  {
    font-size: 25px;
    line-height:1.2;
    text-align: justify;
  }

  .avatar
  {
    width: 70px;
    height: 70px;
  }

  .appimg1
  {
    margin-top: 30px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) { 
  .logo
  {
    width: 60px !important;
    height: 60px !important;
    font-size: 40px;
    border-radius: 15px;
  }

  .LogoText 
  {
    font-size: 60px;
  }

  .Description
  {
    font-size: 30px;
    line-height:1.2;
    text-align: justify;
  }

  .appimg1
  {
    margin-top: 30px;
  }

  .avatar
  {
    width: 90px;
    height: 90px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) { 

  .appimg1
  {
    margin-top: 30px;
  }

  .Description
  {
    font-size: 40px;
    line-height:1.2;
    text-align: justify;
  }
 }

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 
  
 }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,cAAc;EACd,sDAAsD;EACtD,kBAAkB;EAClB,aAAa;;AAEf;;;AAGA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;GAEG,eAAe;GACf,qBAAqB;GACrB,iBAAiB;GACjB,WAAW;AACd;;AAEA;;GAEG,gBAAgB;GAChB,cAAc;GACd,eAAe;GACf;AACH;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,gBAAgB;EAClB;;AAEF;;AAEA,mDAAmD;AACnD;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,2CAA2C;AAC3C;;EAEE;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;CACD;;AAED,wDAAwD;AACxD;;CAEC","sourcesContent":[".App {\n  font-family: 'rollcage', sans-serif;\n  display: block;\n  background: linear-gradient(#e66465, white) !important;\n  text-align: center;\n  height: 100vh;\n\n}\n\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.logo\n{\n  display: inline-block;\n  background-color: red;\n  color: white;\n  font-size: 80px;\n  text-align: center;\n  width: 120px !important;\n  height: 120px !important;\n  border-radius: 20px;\n}\n\n.LogoText\n{\n   font-size: 90px;\n   font-weight: semibold;\n   margin-left: 25px;\n   color:white;\n}\n\n.Description\n{\n   text-align: left;\n   font-size:40px;\n   line-height:1.2;\n   color:white\n}\n\n.appimg1\n{\n  margin-top: 0px;\n}\n\n.avatar\n{\n  width: 100px;\n  height: 100px;\n}\n\n/* Extra small devices (portrait phones, less than 576px) */\n@media (max-width: 575.98px) { \n  .logo\n  {\n    width: 50px !important;\n    height: 50px !important;\n    font-size: 25px;\n    border-radius: 10px;\n  }\n\n  .LogoText \n  {\n    font-size: 50px;\n  }\n\n  .Description\n  {\n    font-size: 20px;\n    line-height:1.2;\n    text-align: justify;\n  }\n\n  .avatar\n  {\n    width: 60px;\n    height: 60px;\n  }\n\n  .appimg1\n  {\n    margin-top: 30px;\n  }\n\n}\n\n/* Small devices (landscape phones, 576px and up) */\n@media (min-width: 576px) and (max-width: 767.98px) { \n  .logo\n  {\n    width: 50px !important;\n    height: 50px !important;\n    font-size: 30px;\n    border-radius: 10px;\n  }\n\n  .LogoText \n  {\n    font-size: 50px;\n  }\n\n  .Description\n  {\n    font-size: 25px;\n    line-height:1.2;\n    text-align: justify;\n  }\n\n  .avatar\n  {\n    width: 70px;\n    height: 70px;\n  }\n\n  .appimg1\n  {\n    margin-top: 30px;\n  }\n}\n\n/* Medium devices (tablets, 768px and up) */\n@media (min-width: 768px) and (max-width: 991.98px) { \n  .logo\n  {\n    width: 60px !important;\n    height: 60px !important;\n    font-size: 40px;\n    border-radius: 15px;\n  }\n\n  .LogoText \n  {\n    font-size: 60px;\n  }\n\n  .Description\n  {\n    font-size: 30px;\n    line-height:1.2;\n    text-align: justify;\n  }\n\n  .appimg1\n  {\n    margin-top: 30px;\n  }\n\n  .avatar\n  {\n    width: 90px;\n    height: 90px;\n  }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 992px) and (max-width: 1199.98px) { \n\n  .appimg1\n  {\n    margin-top: 30px;\n  }\n\n  .Description\n  {\n    font-size: 40px;\n    line-height:1.2;\n    text-align: justify;\n  }\n }\n\n/* Extra large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) { \n  \n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
